import { useRequirePermission } from "../hooks/useHasPermission";
import { PERMISSIONS } from "../utils/permissions";
import EditTicketForm from "../components/EditTicketForm";

const EditTicketPage = ({ ticketId, onNavigate }) => {
  const hasAccess = useRequirePermission(PERMISSIONS.EDIT_TICKETS, onNavigate);

  if (!hasAccess) {
    return null;
  }

  return <EditTicketForm ticketId={ticketId} onNavigate={onNavigate} />;
};

export default EditTicketPage;
